
<div class="rr-image-upload-write-review container">
  <h3>{{ dictionary.Title }}</h3>
  <div class="rr-image-upload-write-review container-output">
    <ul class="rr-image-upload-write-review container-thumbnail">
      <li
        v-for="(item, index) in cachedImages"
        :key="index"
        class="rr-image-upload-write-review img-thumbnail"
      >
        <img :height="scss.imgSize" :width="scss.imgSize" :src="item" alt="" />
        <button
          type="button"
          class="rr-image-upload-write-review btn-close"
          aria-label="Close"
          @click="removeImage($event, index)"
        >
          x
        </button>
      </li>
    </ul>
  </div>
  <div class="rr-image-upload-write-review container-input">
    <span v-show="displayWarning" class="rr-image-upload-warning">{{ messageWarning }}</span>
    <input
      id="rr-fileUpload"
      class="rr-image-upload-write-review rr-file-upload"
      type="file"
      :accept="fileTypes"
      :size="config.AllowedImageSize"
      :maxFiles="config.AllowedImages"
      multiple
      @change="onFileChange($event)"
    />
  </div>
  <div class="rr-image-upload-write-review container-info">
    <h4>{{ dictionary.GuidelinesHeader }}</h4>
    <p>{{ dictionary.Guidelines }}</p>
  </div>
</div>
